/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';
import type { StepUpdateBodyDoc } from './stepUpdateBodyDoc';
import type { StepUpdateCallScriptDoc } from './stepUpdateCallScriptDoc';
import type { StepUpdateMessageDoc } from './stepUpdateMessageDoc';
import type { StepUpdatePriority } from './stepUpdatePriority';
import type { StepUpdateSmsBodyDoc } from './stepUpdateSmsBodyDoc';
import type { StepUpdateSubjectDoc } from './stepUpdateSubjectDoc';
import type { StepUpdateSubjectMode } from './stepUpdateSubjectMode';
import type { StepUpdateTaskNoteDoc } from './stepUpdateTaskNoteDoc';
import type { StepUpdateThreadMode } from './stepUpdateThreadMode';

/**
 * Partial step update — every field optional, ``type`` is invariant.
 *
 * To change a step's type, delete the step and add a new one. This
 * keeps the discriminator semantically meaningful AND avoids the
 * need to validate cross-type field migrations.
 */
export interface StepUpdate {
  schedule?: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay | null;
  priority?: StepUpdatePriority;
  subject_mode?: StepUpdateSubjectMode;
  subject_doc?: StepUpdateSubjectDoc;
  body_doc?: StepUpdateBodyDoc;
  thread_mode?: StepUpdateThreadMode;
  cc?: string[] | null;
  bcc?: string[] | null;
  include_sender_signature?: boolean | null;
  include_unsubscribe_link?: boolean | null;
  invitation_note?: string | null;
  message_doc?: StepUpdateMessageDoc;
  task_note_doc?: StepUpdateTaskNoteDoc;
  call_script_doc?: StepUpdateCallScriptDoc;
  sms_body_doc?: StepUpdateSmsBodyDoc;
}
